import { FieldValues } from 'react-hook-form';
import {
  useCheckboxGroupFieldController,
  UseCheckboxGroupFieldControllerProps,
} from '../../../hooks/form/useCheckboxGroupFieldController';
import ErrorMessage from '../shared/ErrorMessage';
import CheckboxGroup, { CheckboxGroupProps } from '../../library/CheckboxGroup';

export interface CheckboxGroupFieldProps<TFieldValues>
  extends Pick<
      UseCheckboxGroupFieldControllerProps<TFieldValues>,
      'name' | 'rules'
    >,
    Omit<
      CheckboxGroupProps,
      'required' | 'error' | 'onChange' | 'errorMessage'
    > {}

export default function CheckboxGroupField<TFieldValues extends FieldValues>(
  props: CheckboxGroupFieldProps<TFieldValues>,
) {
  const { children, name, rules, ...checkboxGroupFieldProps } = props;

  const {
    field,
    required,
    formState: { errors },
    fieldState: { invalid: error },
  } = useCheckboxGroupFieldController<TFieldValues>({ name, rules });

  return (
    <CheckboxGroup
      required={required}
      error={error}
      errorMessage={<ErrorMessage name={field.name} errors={errors} />}
      {...checkboxGroupFieldProps}
    >
      <input type="hidden" {...field} />
      {children}
    </CheckboxGroup>
  );
}
